/**
 * Pip 6px utilisé dans la sidebar pour signaler une action requise.
 *
 * Cinq couleurs sémantiques :
 * - red    : urgent, à traiter (ex: 3 founder submissions nouvelles)
 * - gold   : à surveiller (ex: 2 deadlines à 14j sur les programmes)
 * - teal   : informationnel (ex: items en cours de review)
 * - green  : nominal, tout va bien
 * - neutral: mode dégradé / data non chargée
 *
 * Règle d'usage (cf. brief section 4) : un pip d'urgence (gold ou red) par
 * section maximum. La règle est enforced dans Sidebar, pas dans cet atom.
 */

export type PipColor = 'red' | 'gold' | 'teal' | 'green' | 'neutral';

const PALETTE: Record<PipColor, string> = {
  red: 'bg-red-500',
  gold: 'bg-amber',
  teal: 'bg-funds',
  green: 'bg-green-500',
  neutral: 'bg-ink-faint',
};

export function NavPip({ color, ariaLabel }: { color: PipColor; ariaLabel?: string }) {
  return (
    <span
      role={ariaLabel ? 'status' : undefined}
      aria-label={ariaLabel}
      className={`inline-block h-1.5 w-1.5 rounded-full ${PALETTE[color]}`}
    />
  );
}
